
import { OtpPromptComponent } from './otp-prompt/otp-prompt.component';
import { HideHeaderDirective } from './../../directives/hide-header.directive';
import { AttributeListComponent } from './attribute-list/attribute-list.component';
import { ScrollbarDirective } from 'app/directives/scrollbar.directive';
import { MenuButtonComponent } from './menu-button/menu-button.component';

import { ImageFallbackDirective } from './../../directives/image-fallback.directive';
import { ResultLayoutToggleComponent } from './result-layout-toggle/result-layout-toggle.component';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { HeaderPopover } from './header/header.popover';
import { HeaderComponent } from './header/header.component';

import { ContactListItemPopover } from './contact-list-item/contact-list-item.popover';
import { VehicleListItemPopover } from './vehicle-list-item/vehicle-list-item.popover';
import { VehicleListItemComponent } from './vehicle-list-item/vehicle-list-item.component';
import { VehicleListComponent } from './vehicle-list/vehicle-list.component';
import { SelectVehicleSearchComponent } from './select-vehicle/select-vehicle-search.component';
import { SelectVehicleComponent } from './select-vehicle/select-vehicle.component';
import { NotificationBadgeComponent } from './notification-badge/notification-badge.component';
import { ContactListItemComponent } from './contact-list-item/contact-list-item.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { SelectContactSearchComponent } from './select-contact/select-contact-search.component';
import { SelectContactComponent } from './select-contact/select-contact.component';
import { EditorPageComponent } from './editor-page/editor-page.component';
import { ContactService } from 'app/services/contact.service';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MainMenuComponent } from './main-menu/main-menu.component';
import { LogoutComponent } from './logout/logout.component';
import { ImageDisplayerComponent } from './image-displayer/image-displayer.component';
import { ContactImageDisplayerComponent } from './contact-image-displayer/contact-image-displayer.component';
import { FieldGroupComponent } from './field-group/field-group.component';
import { FieldComponent } from './field/field.component';
import { ModalDetailsComponent } from './modal-details/modal-details.component';
import { ModalDetailsEditComponent } from './modal-details-edit/modal-details-edit.component';
import { PhoneValidator } from '../../directives/phone-validator.directive';
import { SelectListComponent } from './select-list/select-list.component';
import { SelectListModalComponent } from './select-list/select-list-modal.component';
import { SelectListMultiComponent } from './select-list/select-list-multi.component';
import { SelectListLazyMultiComponent } from './select-list/select-list-lazy-multi.component';
import { SelectListLazyComponent } from './select-list/select-list-lazy.component';
import { ModalIframeComponent } from './modal-iframe/modal-iframe.component';
import { ImageInputComponent } from './image-input/image-input.component';
import { PipesModule } from 'app/pipes/pipes.module';

import { Badge } from '@awesome-cordova-plugins/badge/ngx';
import { SelectContactSearchPopover } from './select-contact/select-contact-search.popover';
import { SignatureComponent } from 'app/components/shared/signature/signature.component';
import { NgDompurifyModule } from '@tinkoff/ng-dompurify';
import { HrefComponent } from './href/href.component';
import { TimePeriodPickerComponent } from './time-period-picker/time-period-picker.component';
import { SelectProductComponent } from './select-product/select-product.component';
import { PriceEditorComponent } from './price-editor/price-editor.component';
import { ModalDetailsPopover } from './modal-details/modal-details.popover';
import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';

import { ReminderListComponent } from './reminder-list/reminder-list.component';
import { ReminderListItemComponent } from './reminder-list-item/reminder-list-item.component';
import { ReminderListItemPopover } from './reminder-list-item/reminder-list-item.popover';
import { RemindersComponent } from './reminders/reminders.component';
import { RemindersPopover } from './reminders/reminders.popover';
import { ReportDynamicParamsComponent } from './report-dynamic-params/report-dynamic-params.component';
import { TextLibraryComponent } from './text-library/text-library.component';
import { BulkUpdateVehicleListItemComponent } from './bulk-update-vehicle-list-item/bulk-update-vehicle-list-item.component';
import { BulkUpdateVehicleListComponent } from './bulk-update-vehicle-list/bulk-update-vehicle-list.component';
import { PdfViewerZoomDirective } from 'app/directives/pdf-viewer-zoom.directive';
import { ProviderQualifyComponent } from './provider-qualify/provider-qualify.component';
import { ProductQuoteComponent } from './product-quote/product-quote.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        IonicModule,
        PipesModule,
        NgDompurifyModule,
        RichTextEditorComponent,
    ],
    exports: [
        SelectListComponent,
        SelectListModalComponent,
        SelectListMultiComponent,
        SelectListLazyMultiComponent,
        SelectListLazyComponent,
        MainMenuComponent,
        ImageDisplayerComponent,
        ContactImageDisplayerComponent,
        FieldGroupComponent,
        FieldComponent,
        EditorPageComponent,
        SelectContactComponent,
        SelectContactSearchComponent,
        ContactListComponent,
        ContactListItemComponent,
        SelectVehicleComponent,
        SelectVehicleSearchComponent,
        VehicleListComponent,
        VehicleListItemComponent,
        NotificationBadgeComponent,
        ModalIframeComponent,
        ImageInputComponent,
        HeaderComponent,
        HeaderPopover,
        SkeletonComponent,
        ResultLayoutToggleComponent,
        SignatureComponent,
        ImageFallbackDirective,
		MenuButtonComponent,
		ScrollbarDirective,
		AttributeListComponent,
		HideHeaderDirective,
		OtpPromptComponent,
		HrefComponent,
        TimePeriodPickerComponent,
        TimePeriodPickerComponent,
        SelectProductComponent,
        PriceEditorComponent,
        ModalDetailsPopover,
        ReminderListComponent,
        ReminderListItemComponent,
        ReminderListItemPopover,
        RemindersComponent,
        ReportDynamicParamsComponent,
        TextLibraryComponent,
        BulkUpdateVehicleListComponent,
        BulkUpdateVehicleListItemComponent,
        PdfViewerZoomDirective,
        ProviderQualifyComponent,
        ProductQuoteComponent
    ],
    declarations: [
        SelectListComponent,
        SelectListModalComponent,
        SelectListMultiComponent,
        SelectListLazyMultiComponent,
        SelectListLazyComponent,
        MainMenuComponent,
        LogoutComponent,
        ImageDisplayerComponent,
        ContactImageDisplayerComponent,
        FieldGroupComponent,
        FieldComponent,
        ModalDetailsComponent,
        ModalDetailsEditComponent,
        PhoneValidator,
        EditorPageComponent,
        SelectContactComponent,
        SelectContactSearchComponent,
        ContactListComponent,
        ContactListItemComponent,
        NotificationBadgeComponent,
        ModalIframeComponent,
        ImageInputComponent,
        SelectVehicleComponent,
        SelectVehicleSearchComponent,
        VehicleListComponent,
        VehicleListItemComponent,
        VehicleListItemPopover,
        ContactListItemPopover,
        SelectContactSearchPopover,
        HeaderComponent,
        HeaderPopover,
        SkeletonComponent,
        ResultLayoutToggleComponent,
        SignatureComponent,
        ImageFallbackDirective,
		MenuButtonComponent,
		ScrollbarDirective,
		AttributeListComponent,
		HideHeaderDirective,
		OtpPromptComponent,
		HrefComponent,
        TimePeriodPickerComponent,
        TimePeriodPickerComponent,
        SelectProductComponent,
        PriceEditorComponent,
        ModalDetailsPopover,
        ReminderListComponent,
        ReminderListItemComponent,
        ReminderListItemPopover,
        RemindersComponent,
        RemindersPopover,
        ReportDynamicParamsComponent,
        TextLibraryComponent,
        BulkUpdateVehicleListComponent,
        BulkUpdateVehicleListItemComponent,
		PdfViewerZoomDirective,
        ProviderQualifyComponent,
        ProductQuoteComponent
    ],
    providers: [
        ContactService,
        EditorPageComponent,
        Badge,
    ]
})
export class SharedModule { }
